var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-article-container"},[_c('article',{ref:"contentContainer"},[_c('div',{ref:"contentMainContainer",staticClass:"article article-main-pal",domProps:{"innerHTML":_vm._s(_vm.processHtml(_vm.content))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }